import c from './AddProcess.module.css'
import { useParams } from 'react-router-dom'

import {
    addRtProcessAndSockets,

} from './../../utils/api'

export const AddProcess = ({
    dtProcess,
    descendantProcesses,
    output,
    parentRtProcess,
    hoveredProcessId,
    setHoveredProcessId,
    onRtProcessAndSocketsAdd
}) => {
    const { id: rtTaskId } = useParams();


    const pseudoId = `[new]${dtProcess?.id}[childOf]${parentRtProcess?.id ? parentRtProcess.id : ""}`;
    const hovered = hoveredProcessId === pseudoId;

    const handleMouseEnter = (event) => {
        event.stopPropagation();
        setHoveredProcessId(pseudoId);
    }

    const handleMouseLeave = (event) => {
        event.stopPropagation();
        setHoveredProcessId(null);
    }

    const handleMouseMove = (event) => {
        event.stopPropagation();
        setHoveredProcessId(pseudoId);
    }

    const handleClick = () => {
        addRtProcessAndSockets(
            rtTaskId,
            dtProcess.id,
            // output ? "output" : "input",
            "both",
            parentRtProcess?.id
        ).then(res => {
            const newRtProcess = res.rt_process
            const newRtSockets = res.rt_sockets
            
            onRtProcessAndSocketsAdd(newRtProcess, newRtSockets)
        }).catch(err => {
            alert("Error adding process")
            console.error(err)
        })
    }

    return (
        <div
            className={c['grid-ctr']}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={hoveredProcessId === null ? handleMouseMove : undefined}
        >
            <div className={c["left-color"]} style={{ backgroundColor: dtProcess.color }}></div>
            <div className={`${c["ctr"]} ${hovered ? c["hovered-process"] : ""}`}>
                <div className={c['body']} onClick={handleClick}>
                    Add {dtProcess.name}
                </div>
            </div>
        </div>
    )
}
